import React from 'react';
import '../style/footer.scss'; 
import logoIcon from '../assets/icons/logotype.svg';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-column footer-column--info">
          <div className="footer-headline">
            <img src={logoIcon} alt="Lobby Logo" className="footer-logo" />
            <span className="body-m copy-lobby">copy.lobby</span>
          </div>
          <div className="footer-paragraph">
            <p className="body-s">Moscow, Russia 2025</p>
            <p className="body-s">Web-studio</p>
          </div>
        </div>

        <div className="footer-column footer-column--contact">
          <div className="footer-contact-group">
            <p className="body-m">Почта для связи</p>
            <p className="body-s-link">copy.lobby.art@gmail.com</p>
          </div>
        </div>
        <div className="footer-column footer-column--contact">
          <div className="footer-contact-group">
            <p className="body-m">Телеграм</p>
            <p className="body-s-link">@copylobby_agency</p>
          </div>
        </div>
        <div className="footer-column footer-column--contact">
          <div className="footer-contact-group">
            <p className="body-m">Behance</p>
            <p className="body-s-link">copy.lobby</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;